
<div>
  <div v-if="error" role="alert" data-testid="error-message">
    <h2 class="text-lg">Error</h2>
    <p>{{ error }}</p>
  </div>
  <LoadingSpinner
    v-if="isLoading"
    data-testid="loading-message"
    class="text-xsoke w-18"
  />
  <ul
    v-if="results"
    class="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-16"
    data-testid="tags-search-results"
  >
    <CollectionObjectTeaser
      v-for="result in results.objectRecords"
      :key="result.objectRecordId"
      :object-record="objectRecordDto(result)"
    />
  </ul>
  <p v-if="results && results.totalObjects === 0">
    No related collection objects found.
  </p>
</div>
